import {RouteRecordRaw} from "vue-router";

import CompetitionIndex from "@/modules/competitions/pages/competitions/Index.vue";
import CompetitionShow from "@/modules/competitions/pages/competitions/Show.vue";
import CompetitionCup from "@/modules/competitions/pages/competitions/Cup.vue";
import CompetitionPlayerLogs from "@/modules/competitions/pages/competitions/PlayerCompetitionLogs.vue";

import DivisionShow from "@/modules/competitions/pages/divisions/Show.vue";
import DivisionTable from "@/modules/competitions/pages/divisions/Table.vue";
import DivisionPlayerCompetitionLogs from "@/modules/competitions/pages/divisions/PlayerCompetitionLogs.vue";
import DivisionMatches from "@/modules/competitions/pages/divisions/Matches.vue";

export const routes: RouteRecordRaw[] = [
  {
    name: 'competitions.index',
    path: '/competitions',
    component: CompetitionIndex,
  },
  {
    name: 'competitions.show',
    path: '/competitions/:id',
    component: CompetitionShow,
  },
  {
    name: 'competitions.cup',
    path: '/competitions/:id/cup',
    component: CompetitionCup,
  },
  {
    name: 'competitions.player-competition-logs',
    path: '/competitions/:id/player-competition-logs',
    component: CompetitionPlayerLogs,
  },
  {
    name: 'divisions.show',
    path: '/divisions/:id',
    component: DivisionShow,
  },
  {
    name: 'divisions.matches',
    path: '/divisions/:id/matches',
    component: DivisionMatches,
  },
  {
    name: 'divisions.table',
    path: '/divisions/:id/table',
    component: DivisionTable,
  },
  {
    name: 'divisions.player-competition-logs',
    path: '/divisions/:id/player-competition-logs',
    component: DivisionPlayerCompetitionLogs,
  }
];